import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {RepetitionMode} from '@birco/rainmesh-api';

export function maxFileSize(maxInMB: number) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      const fileSize = (file.size / Math.pow(1024, 2));
      if (fileSize > maxInMB) {
        return {
          maxFileSize: {
            maxSize: maxInMB,
            actualSize: fileSize.toFixed(1)
          }
        };
      }
      return null;
    }
    return null;
  };
}

export const dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const startDateControl = control.get('startDate');
  const endDateControl = control.get('endDate');

  if (!startDateControl || !endDateControl) return null // {controlMissing: true};
  if (!startDateControl?.valid || !endDateControl?.valid) return null // {datesRequired: true}

  if (!startDateControl.value || !endDateControl.value) return null

  const startDate = new Date(startDateControl.value);
  const endDate = new Date(endDateControl.value);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return {invalidDate: true};

  return startDate >= endDate ? {invalidDateRange: true} : null
}

export const clockTimeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const repetitionMode = group.get('repetitionMode')?.value;
  // const repetitionInterval = group.get('repetitionInterval')?.value;
  const repetitionDays = group.get('repetitionDays')?.value;
  const hasSelectionInRepetitionDays = Object.values(repetitionDays).some(v => v === true);

  // group.get('repetitionInterval')?.setErrors(null);
  group.get('repetitionDays')?.setErrors(null);

  // if (repetitionMode === RepetitionMode.DAILY || repetitionMode === RepetitionMode.WEEKLY) {
  //   if (!repetitionInterval) group.get('repetitionInterval')?.setErrors({ required: true });
  //   if (repetitionInterval < 1) group.get('repetitionInterval')?.setErrors({ min: {min: 1} });
  // }

  if (repetitionMode === RepetitionMode.WEEKLY) {
    if (!hasSelectionInRepetitionDays) {
      group.get('repetitionDays')?.setErrors({ invalidMultiSelection: true });
    }
  }

  const hasErrors =
    // !!group.get('repetitionInterval')?.errors ||
    !!group.get('repetitionDays')?.errors;

  return hasErrors ? { invalidClockTime: true } : null;
};

